import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginApprenantPage = lazy(() => import('../pages/login-apprenant/page'));
const LoginSatisfactionPage = lazy(() => import('../pages/login-satisfaction/page'));
const LoginSatisfactionFinPage = lazy(() => import('../pages/login-satisfaction-fin/page'));
const LoginAdminPage = lazy(() => import('../pages/login-admin/page'));
const EmargementPage = lazy(() => import('../pages/emargement/page'));
const ConfirmationPage = lazy(() => import('../pages/confirmation/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const AdminCoachingPage = lazy(() => import('../pages/admin-coaching/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const CoachingPage = lazy(() => import('../pages/coaching/page'));
const CoachingIndividuelPage = lazy(() => import('../pages/coaching-individuel/page'));
import SatisfactionPage from '../pages/satisfaction/page';
import MerciSatisfactionPage from '../pages/merci-satisfaction/page';
import SatisfactionFinFormationPage from '../pages/satisfaction-fin-formation/page';
import MerciSatisfactionFinPage from '../pages/merci-satisfaction-fin/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login-apprenant',
    element: <LoginApprenantPage />,
  },
  {
    path: '/login-satisfaction',
    element: <LoginSatisfactionPage />,
  },
  {
    path: '/login-satisfaction-fin',
    element: <LoginSatisfactionFinPage />,
  },
  {
    path: '/login-admin',
    element: <LoginAdminPage />,
  },
  {
    path: '/emargement',
    element: <EmargementPage />,
  },
  {
    path: '/confirmation',
    element: <ConfirmationPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/admin-coaching',
    element: <AdminCoachingPage />,
  },
  {
    path: '/satisfaction',
    element: <SatisfactionPage />
  },
  {
    path: '/merci-satisfaction',
    element: <MerciSatisfactionPage />
  },
  {
    path: '/satisfaction-fin-formation',
    element: <SatisfactionFinFormationPage />
  },
  {
    path: '/merci-satisfaction-fin',
    element: <MerciSatisfactionFinPage />
  },
  {
    path: '/coaching',
    element: <CoachingPage />
  },
  {
    path: '/coaching-individuel',
    element: <CoachingIndividuelPage />
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
